import { Types } from "../actions/notificationActions";

const initialState = {
    notifications: {},
    subscribed: {},
    subscribeNotification: {},
    notificationLanguages: [],
    notificationLanguage: {},
    userNotificationLanguage: {},
};

export const notificationReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_NOTIFICATION_LIST:
            return {
                ...state,
                notifications: action.payload || state.notifications,
            };
        case Types.SET_NOTIFICATION_SUBSCRIPTION_OF_USER:
            return {
                ...state,
                subscribed: action.payload || state.subscribed,
            };
        case Types.SET_SUBSCRIBE_NOTIFICATION:
            return {
                ...state,
                subscribeNotification: action.payload || state.subscribeNotification,
            };
        case Types.SET_NOTIFICATION_LANGUAGES:
            return {
                ...state,
                notificationLanguages: action.payload || state.notificationLanguages,
            };
        case Types.SET_NOTIFICATION_LANGUAGE:
            return {
                ...state,
                notificationLanguages: action.payload || state.notificationLanguage,
            };
        case Types.SET_USER_NOTIFICATION_LANGUAGE:
            return {
                ...state,
                userNotificationLanguage: action.payload || state.userNotificationLanguage,
            };
        default:
            return state;
    }
};
